import type { UserDetailsResponse } from "@/utils/api/user-service/models"

/**
 * Extracts the initials from a user's first and last name
 * @param user The user summary object containing firstName and lastName
 * @param fallback Optional fallback string if no initials can be extracted
 * @returns A string with up to two characters representing the user's initials
 */
export function getUserInitials(user: UserDetailsResponse | null | undefined, fallback: string = '?'): string {
  if (!user)
    return fallback

  // Extract first letters of first and last name if available
  const firstInitial = user.firstName?.charAt(0).toUpperCase() || ''
  const lastInitial = user.lastName?.charAt(0).toUpperCase() || ''

  // If we have both initials, return them together
  if (firstInitial && lastInitial) {
    return `${firstInitial}${lastInitial}`
  }

  // If we only have one name, return just that initial
  if (firstInitial || lastInitial) {
    return firstInitial || lastInitial
  }

  // If no name is available, return the fallback
  return fallback
}
